const GLOBAL = {};

export default GLOBAL;
